export const HOME = '/';
export const GAME = '/game';
export const GAME_END = '/game/end';
// USE THIS ENDPOINT FOR LOCAL DEVELOPMENT
//export const BOGGLE_ENDPOINT = "http://localhost:3000/boggle";
// API GATEWAY ENDPOINT FOR AWS LAMBDA
export const BOGGLE_ENDPOINT = "https://3n6e02h3f2.execute-api.us-east-1.amazonaws.com/default/play-boggle";